module.exports = {"150723100":"阿里河镇","150723101":"大杨树镇","150723102":"甘河镇","150723103":"吉文镇","150723104":"诺敏镇","150723105":"乌鲁布铁镇","150723106":"宜里镇","150723107":"克一河镇","150723200":"古里乡","150723201":"托扎敏乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150723.json
// module id = 537
// module chunks = 0